export const environment = {
  production: false,
  base: {
    baseUrl : 'https://api-staging.moba-pro.jp/api/1.0',
    resouceUrl: '',
    appVersion : '1.2.1',
    appname : 'akatsuki-jwt',
    fnckey: 'e5a46W0NS9YYoInB2hhNeFq3dccLD0I5HF4xJoe2jZHSAzFuqFWVbw=='
  },
  tenantid: 38,
  pubsub: {
    topic: ""
  }
};
